<template>
  <div class="bar">
    <el-date-picker
      class="search-datepicker"
      v-model="daterange"
      size="small"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="dd/MM/yyyy"
      :picker-options="rang"
    ></el-date-picker>
    <el-select
      class="search-select"
      v-model="source"
      placeholder="请选择"
      size="small"
      v-if="showSelect"
    >
      <el-option v-for="item in options" :key="item.sence" :label="item.name" :value="item.sence"></el-option>
    </el-select>
    <el-input
      class="search-input"
      placeholder="请输入用户昵称/openid"
      v-model="key"
      size="small"
      clearable
    ></el-input>
    <el-button type="primary" size="mini" @click="handlerSearch">查询</el-button>
  </div>
</template>

<script>
import utils from '@/utils';

export default {
  name: 'UserManaFollow',
  props: {
    showSelect: {
      type: Boolean,
      default: true,
    },
    id: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      searchItem: {
        daterange: '',
        source: 'ALL',
        key: '',
      },
      daterange: '',
      source: 'ALL',
      key: '',
      options: [],
      rang: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  methods: {
    handlerSearch() {
      let ret = {
        begin: this.daterange ? this.moment(this.daterange[0]) : null,
        end: this.daterange ? this.moment(this.daterange[1]) : null,
        key: this.key,
        subscribedScene: this.source,
      };
      if (utils.objectKeysIsEmpty(ret)) {
        this.$message.error('请选择一个筛选条件');
        return false;
      }
      this.$emit('getSearchParams', ret);
    },
    async getSource() {
      let url = `/api/${this.id}/follower/scenes`;
      let res = await this.$http.get(url);
      if (res) {
        this.options = res;
        this.options.unshift({
          sence: 'ALL',
          name: '所有来源',
        });
      }
    },
  },

  created() {
    this.showSelect && this.getSource();
  },
};
</script>
<style lang="scss" scoped>
.bar {
  /deep/ .el-button {
    position: relative;
    top: 1px;
    padding: 7px 20px;
    font-size: 14px;
  }
}
.search {
  &-datepicker {
    width: 230px;
  }
  &-select {
    margin-left: 10px;
    width: 230px;
  }
  &-input {
    margin-left: 10px;
    margin-right: 10px;
    width: 230px;
  }
}
</style>
